import { useCallback } from 'react';

import { usePlayersSearchContext } from '../../../pages/players';
import { PLAYER_PAGE_SIZE } from '../../../shared/shared.constants';

export function PlayerShowMoreSearchResultsButton({
    searchPlayers,
}: {
    searchPlayers: (s: string, filtersActive: boolean, offset: number, isLoadMore: boolean) => Promise<any>;
}) {
    const { dispatch, hasMore, lastSearchText, offset, lastSearchFiltersActive } = usePlayersSearchContext();

    const loadMore = useCallback(async () => {
        const { results, count } = await searchPlayers(
            lastSearchText,
            lastSearchFiltersActive,
            offset + PLAYER_PAGE_SIZE,
            true,
        );
        dispatch({
            type: 'asyncLoadMoreCompleted',
            offset: offset + PLAYER_PAGE_SIZE,
            results: results,
            totalResults: count,
            lastSearchTerm: lastSearchText,
            filtersActive: lastSearchFiltersActive,
        });
    }, [dispatch, lastSearchFiltersActive, lastSearchText, offset, searchPlayers]);

    if (!hasMore) {
        return <></>;
    }
    return (
        <button className="show-more button blue-button medium-button" onClick={() => loadMore()}>
            SHOW MORE
        </button>
    );
}
